import { FeatureCollection } from '@turf/turf';

import { getSoilTableApi } from '@services/soild';
import { decodeTable } from './getFieldTables';

export const getSoilTable = async (boundaryTableGuid: string) => {
  let soil = undefined;
  if (boundaryTableGuid) {
    try {
      const soilFieldDataBase64 = await getSoilTableApi({ tableGuid: boundaryTableGuid });

      soil = decodeTable(soilFieldDataBase64) as FeatureCollection;
    } catch (err) {
      console.error('Could not fetch soils', err);
    }
  }
  return { soil };
};
